import React, {useRef} from "react"
import Block from "./Elements/BackgroundText.js";

import styles from "./Introduction.module.scss";
import Button from "./Global/Button";

import imageMobile from "../images/masthead-bg.jpg";

import src from "../images/masthead-bg.jpg";
import srcRet from "../images/masthead-bg@2x.jpg";
import webp from "../images/masthead-bg.webp";
import webpRet from "../images/masthead-bg@2x.webp";

import Content from "./Elements/Content";

export default function Introduction () {
    const button = useRef(null);


    return (
        <Content>
            <Block classame={styles.Main} color={'white'} container={true} background={{src, srcRet, webp, webpRet}} mobile={imageMobile}>
                <h1>
                    <strong>
                        5G
                    </strong>
                </h1>

                <div className={styles.ButtonWrapper} ref={button}>
                    <Button text={'Investissez'} target={'_blank'} url={'https://ad.doubleclick.net/ddm/clk/545571363;354682647;t'}/>
                </div>
            </Block>
        </Content>
    )
}
